(() => {
  if (customElements.get('senfon-b2b-gallery')) return;

  class SenfonB2BGallery extends HTMLElement {
    constructor() {
      super();
      this.mainImage = this.querySelector('[data-sf-gallery-main]');
      this.mainButton = this.querySelector('[data-sf-gallery-open]');
      this.thumbnails = Array.from(this.querySelectorAll('[data-sf-gallery-thumb]'));
      this.dialog = this.querySelector('[data-sf-gallery-dialog]');
      this.dialogImage = this.querySelector('[data-sf-gallery-dialog-image]');
      this.closeButton = this.querySelector('[data-sf-gallery-close]');
    }

    connectedCallback() {
      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => this.selectImage(thumbnail));
      });

      if (this.mainButton) {
        this.mainButton.addEventListener('click', () => this.openDialog());
      }

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.closeDialog());
      }

      if (this.dialog) {
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeDialog();
        });
      }
    }

    selectImage(thumbnail) {
      if (!this.mainImage) return;

      const src = thumbnail.dataset.src;
      const srcset = thumbnail.dataset.srcset;
      const alt = thumbnail.dataset.alt || '';
      const full = thumbnail.dataset.full || src;

      if (src) this.mainImage.src = src;
      if (srcset) this.mainImage.srcset = srcset;
      this.mainImage.alt = alt;
      this.mainImage.dataset.full = full;

      this.thumbnails.forEach((item) => item.setAttribute('aria-current', 'false'));
      thumbnail.setAttribute('aria-current', 'true');
    }

    openDialog() {
      if (!this.mainImage) return;

      const full = this.mainImage.dataset.full || this.mainImage.currentSrc || this.mainImage.src;

      if (!this.dialog || typeof this.dialog.showModal !== 'function') {
        window.open(full, '_blank', 'noopener');
        return;
      }

      if (this.dialogImage) {
        this.dialogImage.src = full;
        this.dialogImage.alt = this.mainImage.alt || '';
      }

      this.dialog.showModal();
    }

    closeDialog() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }
  }

  customElements.define('senfon-b2b-gallery', SenfonB2BGallery);
})();
